<!-- Add a button and when clicked show ng zorro modal -->
<div class="compiled-component-container"
     [ngClass]="{ 'error': renderError }">

  <!-- Loading States -->
  <div *ngIf="isRendering"
       class="loading-overlay">
    <nz-spin nzSize="large"
             [nzTip]="getLoadingMessage()">
    </nz-spin>
  </div>

  <!-- Component Container - Universal container for both Angular and Flutter components -->
  <div #bundleContainer
       [id]="'bundle_' + component?.id"
       class="bundle-container"></div>

  <!-- Action Buttons -->
  <!-- <pre>
    hideActionButtons: {{ hideActionButtons }}
    allowSourceCodeEditing: {{ allowSourceCodeEditing }}
    allowDisplayingInputData: {{ allowDisplayingInputData }}
    allowDisplayingInputUpdateUsingAI: {{ allowDisplayingInputUpdateUsingAI }}
    allowReRendering: {{ allowReRendering }}
    viewOnly: {{ viewOnly }}
   </pre> -->
  <div *ngIf="!hideActionButtons"
       class="component-render-button-container">

    <button nz-button
            nz-tooltip
            *ngIf="!viewOnly && allowDisplayingInputUpdateUsingAI"
            nzTooltipTitle="Update this component using AI"
            class="ai-button compiled-component-button"
            (click)="displayAIConfigDialog()"><i class="fa-solid fa-sparkles"></i></button>

    <button nz-button
            nz-tooltip
            *ngIf="!viewOnly && allowDisplayingInputData"
            nzTooltipTitle="Display data"
            class="compiled-component-button"
            (click)="toggleDisplayData()"> <i class="fa-regular fa-brackets-curly"></i></button>

    <button nz-button
            nz-tooltip
            *ngIf="!viewOnly && allowReRendering"
            nzTooltipTitle="Render this component again with input/data changes"
            class="compiled-component-button"
            (click)="renderBundle()"><i class="fa-regular fa-rotate"></i></button>

    <button nz-button
            nz-tooltip
            *ngIf="!viewOnly && allowSourceCodeEditing"
            nzTooltipTitle="View/Edit Component Source Code"
            class="compiled-component-button"
            (click)="displayComponentSourceCode()"><i class="fa-regular fa-code"></i></button>
  </div>

  <section *ngIf="componentInputs && _displayData"
           class="component-inputs-container">
    <rappider-json-viewer *ngIf="componentInputs"
                          [data]="componentInputs"
                          [maxLineToDisplay]="100"></rappider-json-viewer>
  </section>

  <div *ngIf="renderError"
       class="error-message">
    <pre>{{ renderError }}</pre>
  </div>
</div>

<nz-modal [(nzVisible)]="displayComponentManifest"
          nzTitle="Component Manifest"
          nzWidth="80%"
          (nzOnCancel)="displayComponentManifest = false">
  <ng-container *nzModalContent>
    <h3>Component Definition</h3>
    <pre>{{ componentDefinition | json }}</pre>
    <h3>Component Inputs</h3>
    <pre>{{ componentInputs | json }}</pre>
    <h3>Component</h3>
    <pre>{{ component | json }}</pre>
  </ng-container>
</nz-modal>


<!-- Show and Ai dialog with an ng zorro modal where it has a title a text area and a cancel and a save/ok button -->
<nz-modal [(nzVisible)]="showAIDialog"
          nzTitle="Update Component Configuration"
          nzCentered
          [nzMask]="false"
          nzClassName="ai-config-modal"
          nzWrapClassName="ai-config-wrap"
          [nzCancelText]="'Close'"
          [nzOkText]="'Ok'"
          [nzOkDisabled]="showSaveConfirmation"
          (nzOnCancel)="showAIDialog = false"
          (nzOnOk)="updateComponentConfigUsingAI()">
  <ng-container *nzModalContent>


    <nz-spin nzTip="AI is analyzing your datasources and component structure, please wait..."
             [nzSpinning]="aiComponentConfigurationInProgress"
             [nzSize]="'large'">

      <div *ngIf="!showSaveConfirmation"
           class="ai-config-container">
        <textarea id="aiConfigPrompt"
                  class="ai-config-textarea"
                  [(ngModel)]="aiConfigPrompt"
                  rows="8"
                  placeholder="Enter your AI suggestions here..."></textarea>
        <label for="aiConfigPrompt"
               class="ai-config-label">Explain what you want to see on this UI component. It should be related with your
          app's data entities</label>
      </div>
      <div *ngIf="showSaveConfirmation"
           class="ai-config-save-confirmation">
        <p class="w-100">Do you want to save the new configuration for this component?</p>
        <div class="w-100 confirmation-button-container">
          <button nz-button
                  nzType="primary"
                  (click)="onConfirmSaveComponentDataConfig()">Save</button>
          <button nz-button
                  (click)="discardAiConfigChanges()">No, discard changes</button>
        </div>
        <section class="explanation-container">
          <h6>How AI Suggests Changes</h6>
          <p>
            The AI analyzes your request and the data schemas to suggest changes to the component configuration.
            It provides a new set of inputs and sample data that can enhance the component's functionality.
          </p>

          <div class="suggested-changes-container">

            <div *ngIf="newComponentDataConfigSummary">
              <b>Updated Config</b>
              <p class="description">The component input configuration has been updated based on your feedback.</p>

              <section>
                <rappider-json-viewer [data]="newComponentDataConfigSummary"
                                      [maxLineToDisplay]="100"></rappider-json-viewer>
              </section>
            </div>

            <div *ngIf="newComponentDataConfig?.config?.filter">
              <b>Suggested Data Filter</b>
              <p class="description">This filter is applied to the data before it is displayed in the component.</p>

              <section>
                <rappider-json-viewer [data]="newComponentDataConfig?.config?.filter"
                                      [maxLineToDisplay]="100"></rappider-json-viewer>
              </section>
            </div>

            <div *ngIf="newComponentDataConfig?.config?.transformationFunction">
              <b>Suggested Data Transformation Function</b>
              <p class="description">This function is used to transform the data after it is fetched from the API and
                before it is displayed in the component.</p>

              <pre>
              {{ newComponentDataConfig?.config?.transformationFunction }}
            </pre>
            </div>

            <div *ngIf="newComponentDataConfig?.config?.data">
              <b>Fetched Data from the Datasource:</b>
              <p class="description">This data is fetched from the API and is used to populate the component.</p>

              <section>
                <rappider-json-viewer [data]="newComponentDataConfig?.config?.data"
                                      [maxLineToDisplay]="100"></rappider-json-viewer>
              </section>
            </div>

            <div *ngIf="newComponentDataConfig?.sampleData">
              <b>Data applied to the component:</b>
              <p class="description">This data is used to populate the component.</p>
              <section>
                <rappider-json-viewer [data]="newComponentDataConfig?.sampleData"
                                      [maxLineToDisplay]="100"></rappider-json-viewer>
              </section>
            </div>

          </div>

        </section>
        <!-- end of explanation-container -->
      </div>
    </nz-spin>


  </ng-container>

</nz-modal>


<!-- COMPONENT INFO MODAL  -->

<rappider-modal [visible]="displayComponentSourceCodeModal"
                [title]="modalTitle"
                [okText]="'Save Code Changes'"
                [fullScreen]="true"
                [footer]="null"
                (okClick)="displayComponentSourceCodeModal = false"
                (cancelClick)="displayComponentSourceCodeModal = false">

<!-- <nz-modal [(nzVisible)]="displayComponentSourceCodeModal"
          [nzTitle]="modalTitle"
          nzWidth="90%"
          [nzFooter]="null"
          nzClassName="component-info-modal"
          [nzMaskClosable]="false"
          [nzOkText]="'Save Code Changes'"
          (nzOnCancel)="displayComponentSourceCodeModal = false"
          (nzOnOk)="displayComponentSourceCodeModal = false"> -->

  <!-- <ng-container *nzModalContent> -->
    <rappider-component-definition-info-files [component]="component"
                                              [componentDefinition]="componentDefinition"
                                              [visible]="displayComponentSourceCodeModal"></rappider-component-definition-info-files>
  <!-- </ng-container> -->

  <ng-template #modalTitle>
    <div class="component-info-modal-title">
      <div class=" ant-modal-title">
        <span class="component-title">{{ componentDefinition?.title}}</span>
        <span> | </span>
        <span class="component-selector-name">{{componentDefinition?.selector }}</span>
      </div>
      <div *ngIf="componentDefinition?.description"
           class="component-info-modal-description">
        <span>{{componentDefinition?.description}}</span>
      </div>
    </div>
  </ng-template>

<!-- </nz-modal> -->
</rappider-modal>
<!-- END OF COMPONENT INFO MODAL   -->
